import React from 'react';
import { Container } from '@mui/material';

import { UserHeader } from 'components/common/Header';
import { TabTitle } from 'components/common/TabTitle';
import PrivacyPolicyScreen from 'components/screens/PrivacyPolicyScreen';

function PrivacyPolicy() {
  return (
    <>
      <TabTitle ns="public" i18nKey="tab.privacy" signLabel="general" />
      <UserHeader />
      <Container maxWidth="md" disableGutters>
        <PrivacyPolicyScreen />
      </Container>
    </>
  );
}

export default PrivacyPolicy;
